import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

const ShowroomLocatorResults = ({ loading, error, storeLocation }) => {
  if (loading) {
    return <div className="text-sm text-gray mt-2">Searching...</div>;
  }

  if (error) {
    return (
      <div className="mt-2 pl-2">
        <div className="text-sm text-red mb-2">
          Error searching for showroom. Please try again.
        </div>
      </div>
    );
  }

  // If we have a store location, show it
  if (storeLocation) {
    return (
      <div className="mt-2 pl-2 pt-2 pb-2 [border-top:1px_solid_#f1f1f1] [border-bottom:1px_solid_#f1f1f1]">
        <div className="text-sm text-gray mb-1">Showroom results:</div>
        <div className="text-sm">
          <Link
            to={storeLocation.url}
            className="text-brand underline hover:no-underline"
          >
            {storeLocation.name}
          </Link>
        </div>
      </div>
    );
  }

  // No store found
  return (
    <div className="mt-2 pl-2 pt-2 pb-2 [border-top:1px_solid_#f1f1f1] [border-bottom:1px_solid_#f1f1f1]">
      <div className="text-sm text-gray mb-1">Showroom results:</div>
      <div className="text-sm text-red mb-1">
        No showroom available within range
      </div>
      <div className="text-sm text-gray">
        Try again or alternatively try our{' '}
        <Link to="/showrooms/virtual/" className="text-brand underline">
          Virtual Showroom
        </Link>
      </div>
    </div>
  );
};

ShowroomLocatorResults.propTypes = {
  loading: PropTypes.bool.isRequired,
  error: PropTypes.object,
  storeLocation: PropTypes.object,
};

export default ShowroomLocatorResults;
